import React, { useState } from 'react';
import { parse, format } from 'date-fns';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint } from '@fortawesome/free-solid-svg-icons';

function OrderItem({ row, onSelect, isSelected, orderSent }) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const order = row.original;

    const data = format(parse(order.created_at, 'dd/MM/yyyy HH:mm:ss', new Date()), 'dd/MM/yyyy');

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const handleCheckboxChange = () => onSelect(order.id);

    return (
        <tr className="relative border-b border-stroke hover:bg-slate-100">
            <td className="text-left xl:p-4 text-sm font-medium">
                <div className="absolute block inset-0 cursor-pointer" onClick={openModal} />
                <input
                    type="checkbox"
                    className="relative"
                    checked={isSelected}
                    onChange={handleCheckboxChange}
                />
            </td>
            <td className="p-2 2xl:p-4 xl:pl-0 text-left text-xs 2xl:text-sm font-medium">{order.order_number}</td>
            <td className="p-2 2xl:p-4">
                <div className="flex items-center gap-2">
                    {/*<img src={`/assets/img/user-icon.png`} alt="Google" className="flex-shrink-0 w-5" />*/}
                    <span className="font-medium text-sm 2xl:text-base text-black leading-tight max-w-80">{order.customer.name}</span>
                </div>
            </td>
            <td className="p-2 text-left 2xl:p-4 text-xs 2xl:text-sm">{order.supplier.name}</td>
            <td className="p-2 text-left 2xl:p-4 text-xs 2xl:text-sm">
                <span className="rounded bg-black px-2 py-1 text-xs font-medium text-white tracking-tight 2xl:tracking-normal whitespace-nowrap" style={{ backgroundColor: order.status_color }}>{order.translated_status}</span>
            </td>
            <td className="p-2 pr-0 text-left 2xl:p-4 xl:pr-0 text-xs 2xl:text-sm">{data}</td>
            <td className="p-2 2xl:p-4">
                <div className="flex items-center gap-1">
                    {/* <a href="" className="bg-secondary w-8 h-8 rounded-full flex items-center justify-center duration-200 ease-in-out hover:bg-opacity-80">
                        <FontAwesomeIcon icon={faEdit} className="text-white ml-[1px] mb-[1px]" />
                    </a> */} 
                    
                    <button
                        className="bg-slate-500 w-8 h-8 rounded-full flex items-center justify-center text-white duration-200 ease-in-out hover:bg-opacity-80"
                        onClick={openModal}
                    >
                        <FontAwesomeIcon icon={faPrint}  />
                    </button>
                </div>
            </td>
        </tr>
    );
}

export default OrderItem;
